
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_REQUEST_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import {fromDTO, toDTO} from './mappers/userFlow';
import { publishAndAwait } from '../../../app/coreSlice';

const createUser = async user => {

	if ( typeof user === 'undefined' ) {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};
	
	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'CUSTOMER',
			subType: 'ADD_OPERATOR',
			message: {
				...toDTO(user),
			},
		},
	});

	const { processMessage, error } = request.response;

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	};

	return fromDTO(processMessage);
};

export default createUser;